import { animated, useTransition, to } from '@react-spring/web';
import cx from 'classnames';
import { Orientation } from '@visx/axis';
import { Text } from '@visx/text';
import useLineTransitionConfig from "../spring-configs/useLineTransitionConfig.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function AnimatedTicks(_ref) {
  let {
    hideTicks,
    horizontal,
    orientation,
    scale,
    tickClassName,
    tickComponent,
    tickLabelProps: allTickLabelProps,
    tickStroke = '#222',
    tickTransform,
    ticks,
    tickLineProps,
    animationTrajectory
  } = _ref;
  const animatedTicks = useTransition(ticks, {
    ...useLineTransitionConfig({
      scale,
      animateXOrY: horizontal ? 'x' : 'y',
      animationTrajectory
    }),
    keys: tick => `tick-${tick.value}-${tick.index}`
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: animatedTicks((_ref2, item, _ref3, index) => {
      let {
        fromX,
        toX,
        fromY,
        toY,
        opacity
      } = _ref2;
      let {
        key
      } = _ref3;
      const tickLabelProps = allTickLabelProps[index] ?? allTickLabelProps[0] ?? {};
      return item == null || key == null ? null : /*#__PURE__*/_jsxs(animated.g, {
        className: cx('visx-axis-tick', tickClassName),
        transform: tickTransform,
        children: [!hideTicks && /*#__PURE__*/_jsx(animated.line, {
          x1: fromX,
          x2: toX,
          y1: fromY,
          y2: toY,
          stroke: tickStroke,
          strokeLinecap: "square",
          strokeOpacity: opacity,
          ...tickLineProps
        }), /*#__PURE__*/_jsx(animated.g, {
          transform: to([toX, toY], (interpolatedX, interpolatedY) => `translate(${interpolatedX},${interpolatedY + (orientation === Orientation.bottom && typeof tickLabelProps.fontSize === 'number' ? tickLabelProps.fontSize ?? 10 : 0)})`),
          opacity: opacity,
          children: tickComponent ? tickComponent({
            ...tickLabelProps,
            x: toX,
            y: toY,
            formattedValue: item?.formattedValue
          }) : /*#__PURE__*/_jsx(Text, {
            ...tickLabelProps,
            children: item?.formattedValue
          })
        }, index)]
      }, key);
    })
  });
}